import { Scope } from '../../../../../enums/scope'
import { isAuthorized } from '../../../../../utils/isAuthorized'

interface BankTransactionsPermissions {
  hasBankReconciliationWriteScope: boolean
  hasBankReconciliationAutoMatchScope: boolean
}

export const getBankTransactionsPermissions = (): BankTransactionsPermissions => ({
  hasBankReconciliationWriteScope: isAuthorized(Scope.BankReconciliationWrite),
  hasBankReconciliationAutoMatchScope: isAuthorized(Scope.BankReconciliationAutoMatch),
})
